<div class="ds-button-toggle-group">
  <label class="button" [class.active]="elvTypeForm.value === 'iban'">
    <div class="bg-container"></div>
    <input
      type="radio"
      name="ELV_type"
      value="iban"
      [formControl]="elvTypeForm"
    />
    <ng-container i18n="@@payment_method.label.elv_iban">IBAN</ng-container>
  </label>
  <label class="button" [class.active]="elvTypeForm.value === 'legacy'">
    <div class="bg-container"></div>
    <input
      type="radio"
      name="ELV_type"
      value="legacy"
      [formControl]="elvTypeForm"
    />
    <ng-container i18n="@@payment_method.label.elv_legacy"
      >Kontonummer / BLZ</ng-container
    >
  </label>
</div>

<div>
  <orderform-inputs-generator
    *ngIf="elvTypeForm.value === 'iban'"
    [data]="cachedData"
    [fields]="ibanFieldList"
    (dataChanges)="onChangeInput($event)"
  ></orderform-inputs-generator>
  <orderform-inputs-generator
    *ngIf="elvTypeForm.value === 'legacy'"
    [data]="cachedData"
    [fields]="legacyFieldList"
    (dataChanges)="onChangeInput($event)"
  ></orderform-inputs-generator>
</div>
